import React, { useMemo } from 'react';
import { MB_Modal } from '@mightybyte/rnw.components.modal';
import { mbTextStyles } from '@mightybyte/rnw.utils.style-utils';
import { AnswerType } from '@sapphicsavvy/business';
import { Image, StyleSheet, Text, View } from 'react-native';
import { FONT_STYLES, textStyles } from '../../../../constants/textStyles';
import { Spacer } from '../../../helperComponents/Spacer';
import { InnerShadow } from '../../../helperComponents/InnerShadow';
import { ShadowView } from '../../../helperComponents/ShadowView';
import { imageUtils } from '../../../../utils/imageUtils';

type MostIdealStatisticsModalProps = {
    type: AnswerType;
    isVisible: boolean;
    onDismiss?: () => void;
    question: string;
    answer: number;
    idealPercentage?: number;
};

export default function MostIdealStatisticsModal({
    type,
    isVisible,
    onDismiss,
    question,
    answer,
    idealPercentage,
}: MostIdealStatisticsModalProps) {
    const answerText = useMemo(() => {
        if (type === AnswerType.percentage) {
            return answer === 1 ? 'YES' : 'NO';
        }
        return `${answer}`;
    }, [answer, type]);
    return (
        <MB_Modal
            isVisible={isVisible}
            onDismiss={onDismiss}
            title=""
            titleStyle={styles.titleText}
            closeButtonXProps={{ color: '#FFFFFF' }}
            childrenWrapperStyle={styles.container}
            withoutScrollView
        >
            <View style={styles.content}>
                <Text style={styles.questionText}>{question}</Text>
                <Spacer height={26} />
                <Text style={styles.noteText}>you said</Text>
                <Text style={styles.headLineText}>{answerText}</Text>
                <Spacer height={26} />
                <InnerShadow style={styles.percentage}>
                    <Text style={styles.percentageText}>
                        {idealPercentage}%
                    </Text>
                </InnerShadow>
                <ShadowView style={styles.shadowLogo}>
                    <View style={styles.logo}>
                        <Image
                            source={imageUtils.images.appIcon}
                            style={styles.logoImage}
                        />
                    </View>
                </ShadowView>
                <Spacer height={26} />
                <Text style={styles.noteText}>
                    of users found this answer to be
                </Text>
                <Text style={styles.headLineText}>IDEAL</Text>
            </View>
        </MB_Modal>
    );
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#6A2C8C',
        width: '90%',
        paddingHorizontal: 0,
        paddingBottom: 0,
        paddingTop: 48,
    },
    titleText: mbTextStyles([
        textStyles.normalText,
        {
            fontSize: 18,
            fontWeight: '600',
        },
    ]),
    content: {
        backgroundColor: '#6A2C8C',
        width: '100%',
        paddingHorizontal: 30,
        paddingBottom: 40,
    },
    questionText: mbTextStyles([
        textStyles.largeText,
        {
            color: '#FFFFFF',
            fontWeight: '600',
            fontFamily: FONT_STYLES.Inter_600_Italic,
            fontStyle: 'italic',
        },
    ]),
    headLineText: mbTextStyles([
        textStyles.largeText,
        {
            fontSize: 42,
            fontWeight: '400',
            fontFamily: FONT_STYLES.Tabasco_400,
            color: '#FCAF41',
        },
    ]),
    noteText: mbTextStyles([
        textStyles.normalText,
        {
            fontSize: 18,
            color: '#FFFFFF',
        },
    ]),
    percentage: {
        alignSelf: 'center',
        borderWidth: 4,
        borderRadius: 20,
        borderColor: '#FCAF41',
        paddingHorizontal: 20,
        paddingTop: 30,
        paddingBottom: 60,
    },
    percentageText: mbTextStyles([
        textStyles.normalText,
        {
            fontSize: 60,
            fontWeight: '700',
            color: '#000000',
        },
    ]),
    shadowLogo: {
        borderRadius: 360,
        alignSelf: 'center',
        marginTop: -60,
    },
    logo: {
        width: 140,
        height: 140,
        overflow: 'hidden',
        borderRadius: 360,
    },
    logoImage: {
        width: 224,
        height: 224,
        position: 'absolute',
        top: -29,
        left: -42,
    },
});
